import { hasActiveIcmRun } from "@/icm/icm-page/utils";
import { hasActiveAiScriptRun } from "@/payroll/ai-script/utils";
import {
  PAY_PERIODS_IDLE_POLL_INTERVAL,
  PAYROLL_RUN_POLL_INTERVAL,
  PAYROLL_RUN_STATUS,
} from "@/payroll/constants";
import type { IPayPeriod } from "@/payroll/payroll.d";

type PolledPayPeriod = Pick<
  IPayPeriod,
  "latest_ai_script_run_status" | "latest_icm_run_status" | "latest_run_status"
>;

const hasActivePeriodRun = (period: PolledPayPeriod) =>
  hasActiveAiScriptRun(period) ||
  hasActiveIcmRun(period) ||
  period.latest_run_status === PAYROLL_RUN_STATUS.pending ||
  period.latest_run_status === PAYROLL_RUN_STATUS.processing;

/**
 * Follow active runs closely, and check less often while idle so the page
 * still notices runs that other users start.
 */
export const getPayPeriodsPollInterval = (
  periods: PolledPayPeriod[] | undefined,
) =>
  periods?.some(hasActivePeriodRun)
    ? PAYROLL_RUN_POLL_INTERVAL
    : PAY_PERIODS_IDLE_POLL_INTERVAL;
